import { Result } from "antd";
import ContactSupport from "components/Integrations/components/ContactSupport";

export const NotFound: React.FC<object> = ({}) => {
  return (
    <Result
      status="404"
      title="Not Found/Unauthorized"
      subTitle={
        <>
          This page either could not be found or you do not have access to it.
          If you think this is an error, please
          <ContactSupport subject={"Error Page Not Found"} />.
        </>
      }
    />
  );
};
